import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/landing',
      name: 'landing',
      component: () => import('./landing/Landing')
    },
    {
      path: '/incl-markt-comm',
      name: 'landing',
      component: () => import('./landing/Landing')
    },
    {
      path: '/reseller',
      name: 'landing',
      component: () => import('./landing/Landing')
    },
    {
      path: '/start',
      name: 'wizard',
      component: () => import('./wizard/Wizard')
    },
    {
      path: '/start-incl-markt-comm',
      name: 'wizard',
      component: () => import('./wizard/Wizard'),
      props: { withTaxId: true }
    },
    {
      path: '/start-reseller',
      name: 'wizard',
      component: () => import('./wizard/Wizard'),
      props: { withTaxId: true, reseller: true }
    },
    {
      path: '*',
      redirect: {
        name: 'landing'
      }
    }
  ]
})
